import * as types from '../../utils/actionTypes'

// SET PREFILL
const setPrefillAction = prefill => ({
  type: types.SET_OFFER_PREFILL,
  payload: prefill,
})

// eslint-disable-next-line
export const setPrefill = prefill =>
  dispatch => dispatch(setPrefillAction(prefill))



// WEBPACK FOOTER //
// ./src/modules/offer/actions.js